import { useCallback } from "react";
import { updateUserInfoWithSwabcode } from "../../../utils/apis/user-service"; // adjust path as needed
import { useAuth } from "../../../utils/context/AuthContext";

export const useUpdateSwabcode = () => {
    const { auth } = useAuth();
    const idToken = auth.idToken;

    return useCallback(
        (
            userId: string,
            swabcode: string | null,
            onSuccess: () => void,
            onError: (error: string) => void
        ) => {
            if (!idToken) {
                onError("Token mancante");
                return;
            }

            updateUserInfoWithSwabcode(userId, idToken, swabcode, onSuccess, onError);
        },
        [idToken]
    );
};